export var MakeNav = function MakeNav() {
  return "display: flex;\n          flex-direction: column;\n          padding: 0;\n          margin: 0;\n          list-style: none;\n\n          @media (min-width: 992px) {\n            flex-direction: row;\n          }";
};
export var MakeNavItem = function MakeNavItem() {
  return "";
};